var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          attrs: {
            cols: 12,
            "form-context": _vm.formContext,
            icon: "inticon-documents",
            title: "Schutzbrief",
          },
          on: { save: _vm.saveBreakdownCoverFormData },
          scopedSlots: _vm._u(
            [
              _vm.formContext.permissions.canCreateRetroactiveChangesNote ===
              true
                ? {
                    key: "after-icons",
                    fn: function () {
                      return [
                        _c("csp-retroactive-changes-modal", {
                          attrs: {
                            "record-id": _vm.recordId,
                            title: "Schutzbrief Kunde",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  }
                : null,
            ],
            null,
            true
          ),
        },
        [
          _vm._v(" "),
          _vm.showChangelogButton
            ? _c("b-row", [
                _c(
                  "div",
                  { staticClass: "col d-flex justify-content-end" },
                  [
                    _c("csp-changelog-modal", {
                      attrs: { "changelog-url": _vm.changelogUrl },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.shouldDisplayInsuranceParent,
                    expression: "shouldDisplayInsuranceParent",
                  },
                ],
                staticClass: "col-12",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Versicherungskonzern",
                  "options-loader": _vm.loadInsuranceParentOptions,
                  property: "insuranceParent",
                  type: "autocomplete",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "display-value",
                      fn: function () {
                        return [
                          _vm.formContext.data.insuranceName
                            ? _c("span", [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.formContext.data.insuranceName)
                                  ),
                                ]),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.formContext.data.insurancePhone
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.formContext.data.insurancePhone)
                                ),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.formContext.data.insuranceEmail
                            ? _c("span", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        "mailto:" +
                                        _vm.formContext.data.insuranceEmail,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.formContext.data.insuranceEmail
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3590221618
                ),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-12",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Versicherungsnummer",
                  property: "insurancePolicyNr",
                  type: "text",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-12",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Konditionen",
                  property: "insuranceText",
                  type: "text",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }